<ng-container *ngIf="initialized">

    <div class="grid mx-0">

        <div class="col-12 te-collapsible-section" [ngClass]="{'collapsed': isResultFullView}">
            <div class="te-collapsible-content">
                <div *ngIf="testCaseDtoList" class="mb-3">
                    <p-panel header="Testfall-Auswahl" class="shadow-none border-round">
                        <div class="flex flex-wrap gap-2 align-items-center">
                            <p-select
                                    [options]="testCaseDtoList.entries"
                                    [(ngModel)]="selectedTestCase"
                                    placeholder="Testfall auswählen"
                                    optionLabel="name"
                                    [filter]="true"
                                    filterPlaceholder="Testfall suchen..."
                                    (onChange)="refreshTestCaseVariables()"
                                    class="col-5 p-0 w-auto" appendTo="body">
                            </p-select>

                            <p-button [disabled]="busy"
                                      icon="fa-solid fa-arrows-rotate {{busy ? 'text-200' : 'text-primary'}} "
                                      styleClass="surface-100" (click)="onRefreshTestCases()"></p-button>

                            <p-select
                                    *ngIf="selectedTestCase"
                                    [options]="outputFormatOptions"
                                    [(ngModel)]="generatePdf"
                                    optionLabel="label"
                                    optionValue="value"
                                    class="w-auto" appendTo="body">
                            </p-select>

                            <p-button [disabled]="busy" icon="fa-sharp fa-solid fa-flask-vial" label="Generieren"
                                      (click)="onGenerate()" *ngIf="selectedTestCase"></p-button>
                        </div>

                        @if (selectedTestCase && contextScenarioVariables.length) {
                            <div class="flex flex-wrap gap-3 align-items-end mt-3">
                                @for (variable of contextScenarioVariables; track variable.alias) {
                                    <div class="flex flex-column gap-1 te-context-scenario">
                                        <label class="text-sm text-color-secondary"
                                               [for]="'te-context-scenario-' + variable.alias">{{ getContextScenarioLabel(variable) }}</label>
                                        <p-select
                                                [inputId]="'te-context-scenario-' + variable.alias"
                                                [options]="contextScenarioOptions[variable.alias]"
                                                [(ngModel)]="selectedContextScenarios[variable.alias]"
                                                [disabled]="busy"
                                                optionLabel="label"
                                                optionValue="key"
                                                (onChange)="onContextScenarioChange()"
                                                class="w-auto" appendTo="body">
                                        </p-select>
                                    </div>
                                }
                            </div>
                        }
                    </p-panel>
                </div>

                <div class="mb-3">
                    <p-panel header="Variablenzuordnung" class="h-full shadow-none border-round">
                        @if (displayableVariables?.length) {
                            <p-table [value]="displayableVariables" class="table-gray-header mt-3"
                                     styleClass="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Name</th>
                                        <th>Alias</th>
                                        <th>Status</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-variable>
                                    <tr>
                                        <td class="py-3">{{ variable.name }}</td>
                                        <td class="py-3 text-sm text-color-secondary">{{ variable.alias }}</td>
                                        <td class="py-3">
                                            <span *ngIf="!variable.useCaseVariable" class="p-error">Mapping fehlt</span>
                                            <span *ngIf="variable.useCaseVariable"
                                                  class="p-2 border-round-md font-medium"
                                                  [ngStyle]="{color: 'var(--green-600)'}">
                                                {{ variable.useCaseVariable.name }}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        } @else {
                            <div class="text-center text-color-secondary py-4">Keine Daten vorhanden</div>
                        }
                    </p-panel>
                </div>

                <div *ngIf="occurredException">
                    <p-messages severity="error">{{ occurredException }}</p-messages>
                    <p-messages *ngIf="occurredExceptionDetails" severity="error">{{ occurredExceptionDetails }}
                    </p-messages>
                </div>
            </div>
        </div>

        <div class="col-12" *ngIf="templateGenerateResponse">
            <p-panel class="shadow-none border-round">
                <ng-template pTemplate="header">
                    <div class="flex align-items-center gap-2">
                        <span class="font-semibold">Testergebnis</span>
                        <span class="text-sm text-color-secondary">({{ generatePdf ? 'PDF' : 'HTML' }})</span>
                        @for (hint of contextDataSourceHints; track hint.alias) {
                            <p-tag [value]="hint.label" [severity]="hint.severity" [styleClass]="hint.styleClass"
                                   [pTooltip]="hint.tooltip" tooltipPosition="top"
                                   class="te-context-data-source"></p-tag>
                        }
                    </div>
                </ng-template>
                <ng-template pTemplate="icons">
                    <p-button
                            [icon]="isResultFullView ? 'fa-regular fa-chevron-down text-color-secondary' : 'fa-regular fa-chevron-up text-color-secondary'"
                            styleClass="surface-200" size="small" (click)="isResultFullView = !isResultFullView"
                            [pTooltip]="isResultFullView ? 'Verkleinern' : 'Vollbild'" tooltipPosition="top"></p-button>
                    <p-button [disabled]="busy" icon="fa-solid fa-arrows-rotate text-color-secondary"
                              styleClass="surface-200 ml-2" size="small" (click)="onRefreshResult()"></p-button>
                    <p-button icon="fa-regular fa-times text-color-secondary"
                              styleClass="surface-200 ml-2" size="small" (click)="onHideResult()"></p-button>
                </ng-template>

                @if (trustedGenerateResponseHtml) {
                    <div class="card shadow-none px-0" style="height:99vh;">
                        <iframe
                                [srcdoc]="trustedGenerateResponseHtml"
                                sandbox="allow-scripts allow-same-origin"
                                loading="lazy"
                                height="100%"
                                width="100%"
                                style="border:0;"
                        ></iframe>
                    </div>
                }

                @if (trustedGenerateResponsePdf) {
                    <iframe width="100%" height="800px" [src]="trustedGenerateResponsePdf"></iframe>
                }

            </p-panel>
        </div>

    </div>

</ng-container>
